<template>
  <div class="tabs_box">
    <el-tabs type="card" tab-position="top" >
        <el-tab-pane label="实时数据">
          <realtime-data></realtime-data>
        </el-tab-pane>
        <el-tab-pane label="过程数据">
          <process-data></process-data>
        </el-tab-pane>
        <el-tab-pane label="工艺数据">
          <craft-data></craft-data>
        </el-tab-pane>
        <el-tab-pane label="报警数据">
          <warm-data></warm-data>
        </el-tab-pane>
      </el-tabs>
  </div>
</template>
<script>

import realtimeData from './realtimedata/index'
import processData from './processdata/index'
import craftData from './craftdata/index'
import warmData from './warmdata/index'


export default {
  name: 'equipment',
  components: {
    realtimeData,
    processData,
    craftData,
    warmData
  }

};
</script>

<style lang="scss" scoped>
 
  .el-tabs{
    margin: 18px;
  }
  // /deep/ .el-tabs--top{
  //   height: 680px !important;
  // }

  // .table_bottom{
  //   margin-bottom: 18px;
  // }
</style>  